import type { VoidFunctionComponent } from 'react';

import Flex from '../../../generic/Flex';
import FormGroup from '../../../generic/Forms/FormGroup';
import Text from '../../../generic/Text';
import Toggle from '../../../generic/Toggle';
import type { GeneralSettings } from '../../../../../shared/settings/general';

import styles from './General.module.less';

type Props = {
  settings: GeneralSettings;
  onUpdateSettings: (settings: Partial<GeneralSettings>) => void;
  isDisabled: boolean;
};

const FeaturesSection: VoidFunctionComponent<Props> = ({ settings, onUpdateSettings, isDisabled }) => {
  return (
    <div className={styles.features}>
      <hr />
      <Text.H3>Features</Text.H3>
      <div>
        <FormGroup>
          <Flex direction="row" justify="space-between">
            <div>
              <div className={styles.featureName}>License Conclusion</div>
              <div className={styles.featureDescription}>
                Enables the ability to conclude licenses and adds related license policy settings.
                This global setting will only take effect on individual projects upon their next analysis.
              </div>
            </div>
            <Toggle
              checked={settings.licenseConcludedEnabled}
              onChange={(value) => onUpdateSettings({ licenseConcludedEnabled: value })}
              icons={false}
              isDisabled={isDisabled}
            />
          </Flex>
        </FormGroup>
      </div>
    </div>
  );
};

export default FeaturesSection;
